import BaseServeTable from '@components/table/serve/base-serve-table.vue'
import BaseTable from '@components/table/client/base-client-table.vue'
import FieldGroup from '@components/field/field-group.vue'
import Loading from '@components/loading.vue'
import PageOption from '@components/page-option.vue'
import TransField from '@components/trans-field.vue'
import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

Vue.component('BaseServeTable', BaseServeTable)
Vue.component('FieldGroup', FieldGroup)
Vue.component('TransField', TransField)
Vue.component('BaseTable', BaseTable)
Vue.component('LoadingComponent', Loading)
Vue.component('Loading', Loading)
Vue.component('PageOption', PageOption)
Vue.component('PageLayout', PageOption)
Vue.component(
  'loading-container',
  require('@components/loading-container.vue').default
)
const requireComponent = require.context('@components/base', true, /\.vue$/)

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  Vue.component(`${componentName}`, componentConfig.default || componentConfig)
})
